import api from "./api";

// Count-only Beacon analytics. De-duplicated here in the visitor's own browser (once per
// tab session per day); nothing identifying is ever sent, just the event name.
export const beaconHit = (handle, event, { extra = "", teaser = false } = {}) => {
  if (!handle) return;
  const k = `bh:${handle}:${event}:${extra}:${new Date().toISOString().slice(0, 10)}`;
  try { if (sessionStorage.getItem(k)) return; sessionStorage.setItem(k, "1"); } catch { /* private mode */ }
  api.post(teaser ? `/beacon/teaser/${handle}/hit` : `/beacon/view/${handle}/hit`, { event }).catch(() => {});
};
